// Maps a free-form location_name string to a country flag emoji by checking
// for known city or country tokens. Returns empty string when nothing matches.
const CITY_TO_FLAG: Array<[RegExp, string]> = [
  [/helsinki|finland/i, "🇫🇮"],
  [/paris|france/i, "🇫🇷"],
  [/berlin|germany|deutschland/i, "🇩🇪"],
  [/amsterdam|netherlands|holland/i, "🇳🇱"],
  [/new york|brooklyn|harlem|manhattan|queens|bronx/i, "🇺🇸"],
  [/austin|texas/i, "🇺🇸"],
  [/chicago|illinois/i, "🇺🇸"],
  [/united states|\busa\b/i, "🇺🇸"],
  [/cape town/i, "🇿🇦"],
  [/johannesburg|joburg|soweto|sandton/i, "🇿🇦"],
  [/south africa/i, "🇿🇦"],
  [/são paulo|sao paulo|rio de janeiro|brazil|brasil/i, "🇧🇷"],
  [/bogotá|bogota|medellín|medellin|colombia/i, "🇨🇴"],
  [/buenos aires|argentina/i, "🇦🇷"],
  [/london|england|united kingdom|\buk\b/i, "🇬🇧"],
  [/madrid|barcelona|spain|españa/i, "🇪🇸"],
  [/rome|milan|italy|italia/i, "🇮🇹"],
  [/tokyo|japan/i, "🇯🇵"],
  [/sydney|melbourne|australia/i, "🇦🇺"],
  [/toronto|vancouver|canada/i, "🇨🇦"],
  [/mexico|méxico/i, "🇲🇽"],
  [/india|mumbai|delhi|bangalore/i, "🇮🇳"],
];

export function countryFlag(location: string | null | undefined): string {
  if (!location) return "";
  for (const [re, flag] of CITY_TO_FLAG) if (re.test(location)) return flag;
  return "";
}
